$(function () {
  //Sliders
  $('.frame--transactions').slick({
    dots: false,
    arrows: true,
    infinite: false,
    speed: 300,
    adaptiveHeight: true,
    autoplay: false,
    autoplaySpeed: 5000,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [{
      breakpoint: 1040,
      settings: {
        slidesToShow: 3
      }
    }, {
      breakpoint: 780,
      settings: {
        slidesToShow: 2
      }
    }, {
      breakpoint: 580,
      settings: {
        slidesToShow: 1
      }
    }]
  });
});